export default {"src":"/_next/static/media/transit.e6b3faa6.svg","height":512,"width":512};